var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoomPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 442,
    height: 285,
    viewBox: "0 0 442 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 442,
    height: 285,
    fill: "#E7E1D5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.051 216.83C148.483 216.83 147.212 215.559 147.212 213.991V103.256C147.212 101.688 148.483 100.417 150.051 100.417C151.619 100.417 152.889 101.688 152.889 103.256V213.991C152.889 215.559 151.619 216.83 150.051 216.83Z",
    fill: "#8C808A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.02 144.458C161.452 144.458 160.181 143.188 160.181 141.62V103.256C160.181 101.688 161.452 100.417 163.02 100.417C164.588 100.417 165.859 101.688 165.859 103.256V141.62C165.859 143.188 164.588 144.458 163.02 144.458Z",
    fill: "#FF656B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.771 62.5164H278.249V107.359H209.771V62.5164Z",
    fill: "#FFE9C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M278.25 94.0373L265.779 80.3185C263.733 78.0462 260.17 78.0462 258.124 80.3185L241.068 99.2643L248.247 107.238L278.25 107.359V94.0373Z",
    fill: "#009E65"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M258.966 80.3185L278.25 100.46V94.0377L265.778 80.3189C263.867 78.1955 260.63 78.0576 258.545 79.9034C258.691 80.0322 258.832 80.1701 258.966 80.3185Z",
    fill: "#008954"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.246 107.238L229.802 86.7509C227.964 84.709 224.761 84.709 222.923 86.7509L209.771 101.36V107.359L248.246 107.238Z",
    fill: "#00E0A7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M229.802 86.751C227.974 84.7209 224.8 84.7114 222.956 86.7181C222.967 86.7298 222.979 86.7393 222.989 86.751L241.434 107.238L209.771 107.338V107.359L248.247 107.238L229.802 86.751Z",
    fill: "#00C988"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.477 220.814H134.625V220.387C134.625 214.973 139.013 210.584 144.427 210.584H155.675C161.089 210.584 165.477 214.973 165.477 220.387V220.814Z",
    fill: "#FF656B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155.675 210.584H148.862C154.276 210.584 158.664 214.973 158.664 220.387V220.814H165.477V220.387C165.477 214.973 161.088 210.584 155.675 210.584Z",
    fill: "#FF3E4C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M241.749 81.6479C244.588 81.299 246.607 78.7144 246.259 75.8749C245.91 73.0354 243.325 71.0163 240.486 71.3652C237.646 71.714 235.627 74.2987 235.976 77.1382C236.325 79.9777 238.909 81.9967 241.749 81.6479Z",
    fill: "#FFDC00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M287.354 51.5833H200.667C200.162 51.5833 199.705 51.7881 199.374 52.119L209.771 62.5163H211.6H276.421H278.249L288.647 52.119C288.316 51.7881 287.859 51.5833 287.354 51.5833Z",
    fill: "#E8834D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M288.647 117.756L278.249 107.359H276.421H211.6H209.771L199.374 117.756C199.705 118.087 200.162 118.292 200.667 118.292H287.354C287.859 118.292 288.316 118.087 288.647 117.756Z",
    fill: "#E8834D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M209.771 107.359V105.53V64.3451V62.5164L199.374 52.1191C199.043 52.4501 198.838 52.9073 198.838 53.412V116.463C198.838 116.969 199.043 117.426 199.374 117.756L209.771 107.359Z",
    fill: "#BC6640"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M278.25 64.3449V105.531V107.359L288.647 117.757C288.978 117.426 289.182 116.968 289.182 116.464V53.4122C289.182 52.9072 288.977 52.45 288.647 52.1194L278.25 62.5167V64.3449Z",
    fill: "#BC6640"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M171.209 106.662H128.893C127.678 106.662 126.777 105.532 127.048 104.348L136.138 64.59C136.334 63.7294 137.1 63.1194 137.982 63.1194H162.119C163.002 63.1194 163.768 63.7298 163.964 64.59L173.053 104.348C173.325 105.532 172.424 106.662 171.209 106.662Z",
    fill: "#FFE9C8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M162.12 63.1191H156.815L166.77 106.662H171.209C172.424 106.662 173.325 105.532 173.054 104.347L163.964 64.5901C163.768 63.7295 163.002 63.1191 162.12 63.1191Z",
    fill: "#FFDCA7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M195.821 193.765H292.2V220.814H195.821V193.765Z",
    fill: "#BC6640"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M285.387 193.765H292.199V220.814H285.387V193.765Z",
    fill: "#A05638"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M195.821 220.814H175.661C174.615 220.814 173.768 219.966 173.768 218.921V180.384C173.768 174.294 178.705 169.357 184.794 169.357C190.884 169.357 195.821 174.294 195.821 180.384V220.814H195.821Z",
    fill: "#FF9A00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M184.795 169.357C183.606 169.357 182.462 169.548 181.389 169.896C185.811 171.332 189.009 175.483 189.009 180.384V220.814H195.821V180.384C195.821 174.294 190.885 169.357 184.795 169.357Z",
    fill: "#EF8800"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M312.36 220.814H292.2V180.384C292.2 174.294 297.136 169.357 303.226 169.357C309.316 169.357 314.252 174.294 314.252 180.384V218.921C314.252 219.966 313.405 220.814 312.36 220.814Z",
    fill: "#FF9A00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M303.226 169.357C302.037 169.357 300.893 169.548 299.82 169.896C304.242 171.332 307.44 175.483 307.44 180.384V220.814H312.36C313.406 220.814 314.253 219.967 314.253 218.922V180.384C314.253 174.294 309.316 169.357 303.226 169.357Z",
    fill: "#EF8800"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M195.821 180.384V193.765H292.2V180.384C292.2 174.294 297.136 169.357 303.226 169.357V156.413C303.226 148.268 296.623 141.665 288.478 141.665H199.543C191.398 141.665 184.795 148.268 184.795 156.413V169.357C190.885 169.357 195.821 174.294 195.821 180.384Z",
    fill: "#E8834D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M288.478 141.665H281.666C289.81 141.665 296.413 148.268 296.413 156.413V162.428C296.413 163.188 295.953 163.865 295.257 164.17C289.015 166.896 285.387 172.535 285.387 176.977V193.765H292.2V180.384C292.2 174.294 297.136 169.357 303.226 169.357V156.413C303.226 148.268 296.623 141.665 288.478 141.665Z",
    fill: "#D66E41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomPlaceholder);
export default __webpack_public_path__ + "static/media/room-placeholder.a547b54efce0051ef845dbb933642bfc.svg";
export { ForwardRef as ReactComponent };